import { useMemo } from 'react'
import theme from 'theme'
import { Box, IconButton } from '@material-ui/core'
import { ChipStatus } from '@/components'
import { Links } from './styles'
import api from '@/services/api'
import { any, equals } from 'ramda'

import pdfIcon from '@/assets/images/icons/pdf.png'
import xmlIcon from '@/assets/images/icons/xml.png'

const INVOICE_STATUS_LABEL = {
  denied: 'Denegada',
  canceled: 'Cancelada',
}

const INVOICE_STATUS = {
  denied: 'denied',
  canceled: 'canceled',
}

export function DownloadLinks({ invoice }) {
  const isBlockedForDownload = (status) =>
    any(equals(status), [INVOICE_STATUS.denied, INVOICE_STATUS.canceled])

  const status = invoice.eletronic_invoice?.nfe_status

  const links = useMemo(() => {
    const token = api.defaults.headers['Authorization']

    return {
      xml: invoice._links.xml.concat(`?t=${token}`),
      pdf: invoice._links.pdf.concat(`?t=${token}`),
    }
  }, [invoice])

  function handleDownload(hrefBase) {
    const token = api.defaults.headers['Authorization']
    const href = hrefBase.concat(`?t=${token}`)

    const downloadLink = document.createElement('a')
    downloadLink.href = href
    downloadLink.target = '_blank'
    downloadLink.rel = 'noreferrer'
    downloadLink.click()
    downloadLink.remove()
  }

  if (isBlockedForDownload(status)) {
    return (
      <ChipStatus
        label={INVOICE_STATUS_LABEL[status]}
        background={theme.palette.error.main}
      />
    )
  }

  // <a href="https://www.flaticon.com/free-icons/pdf" title="pdf icons">Pdf icons created by Deylotus Creative Design - Flaticon</a>

  return (
    <Links>
      <IconButton
        size="small"
        title="Download XML"
        aria-label="Download XML"
        onClick={() => handleDownload(links.xml)}
      >
        {/* <Code /> */}
        <Box component="img" src={xmlIcon} alt="PDF" height={30} width={30} />
      </IconButton>

      <IconButton
        size="small"
        title="Download PDF"
        aria-label="Download PDF"
        onClick={() => handleDownload(links.pdf)}
      >
        {/* <PictureAsPdf /> */}
        <Box component="img" src={pdfIcon} alt="PDF" height={30} width={30} />
      </IconButton>
    </Links>
  )
}
